import csf from './core/initCSF';

export default csf;
